import React from 'react';
import { Row, Col, Card, Button, Spinner } from 'react-bootstrap';

import { CaDownloadButton } from '../Certificates/CaDownloadButton';

interface ActionsCardProps {
  isConfigured: boolean;
  isEReceiptConfigLoading: boolean;
  onSendEReceiptConfig: () => void;
  isSyncLoading: boolean;
  syncProgress: { synced: number; total: number } | null;
  onSyncDocuments: () => void;
}

export const ActionsCard: React.FC<ActionsCardProps> = ({
  isConfigured,
  isEReceiptConfigLoading,
  onSendEReceiptConfig,
  isSyncLoading,
  syncProgress,
  onSyncDocuments,
}) => (
  <Row className="mb-4">
    <Col lg={8}>
      <Card>
        <Card.Header>
          <Card.Title className="mb-0">Akcje</Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="d-flex gap-2 flex-wrap">
            <CaDownloadButton />
            <Button
              variant="primary"
              onClick={onSendEReceiptConfig}
              disabled={!isConfigured || isEReceiptConfigLoading}
            >
              {isEReceiptConfigLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Wysyłanie...
                </>
              ) : (
                'Wyślij konfigurację e-paragonów'
              )}
            </Button>
            <Button
              variant="outline-primary"
              onClick={onSyncDocuments}
              disabled={!isConfigured || isSyncLoading}
            >
              {isSyncLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  {syncProgress
                    ? `Synchronizacja ${syncProgress.synced}/${syncProgress.total}...`
                    : 'Synchronizacja...'}
                </>
              ) : (
                'Synchronizuj dokumenty'
              )}
            </Button>
          </div>
        </Card.Body>
      </Card>
    </Col>
  </Row>
);
